import { calculateEstimatedImpressionsRequest } from "@common";
import { AppState, campaignBudgetForm, campaignCreativesForm, PendingCampaign } from "@store";
import { call, put, select } from "redux-saga/effects";
import { campaignMediaPlanFormForEstimatedImpression } from "../state";

let recalculateRequestId = 0;

export function* recalculateEstimatedImpression() {
    const state: AppState = yield select();
    const mediaPlanForm = campaignMediaPlanFormForEstimatedImpression.selector(
        state.campaignState.campaignMediaPlanForm
    );
    const creativesForm = campaignCreativesForm.selector(state.campaignState.campaignCreativesForm);
    const budgetForm = campaignBudgetForm.selector(state.campaignState.campaignBudgetForm);

    if (!mediaPlanForm.isValid || !creativesForm.isValid || !budgetForm.isValid) {
        return;
    }

    const formData: PendingCampaign = {
        ...mediaPlanForm.data,
        ...creativesForm.data,
        ...budgetForm.data,
        budget: budgetForm.data.budget || 0
    } as any; //TODO: as any should delete

    try {
        recalculateRequestId++;

        const params = {
            requestId: recalculateRequestId
        };

        yield put(calculateEstimatedImpressionsRequest.actions.running(params));

        const result: typeof calculateEstimatedImpressionsRequest.types.response = yield call(
            calculateEstimatedImpressionsRequest,
            params,
            formData
        );

        if (params.requestId === recalculateRequestId) {
            if (result.ok === true) {
                yield put(calculateEstimatedImpressionsRequest.actions.ok(params, result));
            } else {
                yield put(calculateEstimatedImpressionsRequest.actions.error(params, result as any));
            }
        }
    } catch (e) {
        console.log("get Estimated Impressions error", e);
    }
}
